import { ToastrService } from "ngx-toastr";
import { Component, Inject, OnInit, OnDestroy } from "@angular/core";
import { GlobalConstants } from "app/common/global-constants";
import {
  UserPermissionsStatus,
  resourceType,
} from "../../../../common/manage-permission";
import { AuthenticationService } from "../../../../services/authentication.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { viewLabels } from "../../../../common/common-constants";
import {
  filterByCarrierName,
  transformRequestedResourcePermissions,
} from "../../../../common/permission-utils";

@Component({
  selector: "app-view-updated-user-permissions",
  templateUrl: "./view-updated-user-permissions.component.html",
  styleUrls: ["./view-updated-user-permissions.component.scss"],
})
export class ViewUpdatedUserPermissionsComponent implements OnInit, OnDestroy {
  public loading = false;
  public getAllRequestedPermissionsUrl =
    GlobalConstants.GET_ALL_REQUESTED_PERMISSIONS;
  public requestedResourcePermissions = [];
  public requestedResourcePermissionsList = [];
  public user: any;
  public carrierName: string = "";
  private destroy$ = new Subject<void>();
  public viewLabels = viewLabels;

  constructor(
    @Inject("RequestsService") private requestsService,
    @Inject("AuthenticationService")
    private readonly authenticationService: AuthenticationService,
    private toastrService: ToastrService,
    @Inject("DialogService") private dialogService,
  ) {}

  ngOnInit(): void {
    this.getAllRequestedPermissions();
    this.user = this.authenticationService.getUserDetails();
  }

  public findByCarrierName() {
    this.requestedResourcePermissions = filterByCarrierName(
      this.requestedResourcePermissionsList,
      this.carrierName,
    );
  }

  private getAllRequestedPermissions() {
    this.loading = true;
    this.requestsService
      .put(this.getAllRequestedPermissionsUrl, {
        requestStatusList: [
          UserPermissionsStatus.APPROVED,
          UserPermissionsStatus.REJECTED,
        ],
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.loading = false;
          this.requestedResourcePermissionsList =
            transformRequestedResourcePermissions(data?.resourcePermissions);
          this.requestedResourcePermissions =
            this.requestedResourcePermissionsList;
        },
        (error) => {
          this.loading = false;
          this.toastrService.error(error, GlobalConstants.TITLE_ERROR);
        },
      );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
